import AutoFusGroupSvg from 'src/assets/images/auto-fus-group.svg';
import styled from 'styled-components';

export const AutoFusGroupLogo = styled(AutoFusGroupSvg)`
  height: 1.3125rem;
`;
